<template>
    <div>
        <v-row no-gutters>
            <v-col cols="12">
                <v-data-table
                    id="virtual-scroll-table"
                    disable-pagination
                    hide-default-footer
                    :headers="headers"
                    :items="quoteCompleteData"
                    class="elevation-0"
                    :mobile-breakpoint="0"
                    :loading="loading"
                    :style="{ height: `${this.quotesHeight}px` }"
                    item-key="scope.id"
                >
                    <template v-slot:top>
                        <v-toolbar
                            flat
                            :style="{
                                'background-color': '#eeeeee !important',
                            }"
                        >
                            <v-toolbar-title
                                >INSTALLATION INDICATORS</v-toolbar-title
                            >
                        </v-toolbar>
                    </template>

                    <!--ITEMS-->
                    <template v-slot:[`item.scopeName`]="{ item }">
                        <div class="my-4">
                            <p class="my-0 mx-0">
                                {{ item.scope.reference }}
                            </p>
                        </div>
                    </template>
                    <template v-slot:[`item.associateScopes`]="{ item }">
                        <div class="my-0">
                            <div
                                v-for="(obj, index) in item.scope
                                    ?.associateScopes"
                                :key="index"
                            >
                                <v-tooltip right>
                                    <template v-slot:activator="{ on, attrs }">
                                        <p
                                            class="my-0 font-weight-medium"
                                            v-bind="attrs"
                                            v-on="on"
                                        >
                                            {{ obj.scope }}
                                        </p>
                                    </template>
                                    <span
                                        >Quote: {{ obj.quote }} Scope:
                                        {{ obj.scope }}</span
                                    >
                                </v-tooltip>
                            </div>
                        </div>
                    </template>
                    <template v-slot:[`item.sqft`]="{ item }">
                        <div class="my-4">
                            <p class="my-0 mx-0">
                                {{ item.scope.SQFT || 0 }}
                            </p>
                        </div>
                    </template>
                    <template v-slot:[`item.installation`]="{ item }">
                        <div class="my-4">
                            <p class="my-0 mx-0">
                                {{
                                    formatCurrency(
                                        item.scope.installationValue,
                                        item.currency
                                    )
                                }}
                            </p>
                        </div>
                    </template>
                    <template v-slot:[`item.expected`]="{ item }">
                        <div class="my-4">
                            <p class="my-0 mx-0">
                                {{
                                    formatCurrency(
                                        parseFloat(
                                            item.scope.installationValue
                                        ) > 0 && parseFloat(item.scope.SQFT) > 0
                                            ? parseFloat(
                                                  item.scope.installationValue
                                              ) / parseFloat(item.scope.SQFT)
                                            : 0,
                                        item.currency
                                    )
                                }}
                            </p>
                        </div>
                    </template>
                    <template v-slot:[`item.installationTime`]="{ item }">
                        <div class="my-4">
                            <p class="my-0 mx-0">
                                {{
                                    item.scope.hours
                                        ? item.scope.hours.toFixed(2)
                                        : 0
                                }}
                            </p>
                        </div>
                    </template>
                    <template v-slot:[`item.totalInstallation`]="{ item }">
                        <div class="my-4">
                            <p class="my-0 mx-0">
                                {{
                                    formatCurrency(
                                        item.scope.totalInstallation || 0,
                                        item.currency
                                    )
                                }}
                            </p>
                        </div>
                    </template>
                    <template v-slot:[`item.real`]="{ item }">
                        <div class="my-4">
                            <p class="my-0 mx-0">
                                {{
                                    formatCurrency(
                                        parseFloat(
                                            item.scope.totalInstallation || 0
                                        ) > 0 && parseFloat(item.scope.SQFT) > 0
                                            ? parseFloat(
                                                  item.scope
                                                      .totalInstallation || 0
                                              ) / parseFloat(item.scope.SQFT)
                                            : 0,
                                        item.currency
                                    )
                                }}
                            </p>
                        </div>
                    </template>
                    <template v-slot:[`item.efficiency`]="{ item }">
                        <div class="my-4">
                            <p
                                class="my-0 mx-0"
                                :class="{
                                    'text-green':
                                        calculatedExecution(item) <= 100,
                                    'text-red': calculatedExecution(item) > 100,
                                }"
                            >
                                {{ calculatedExecution(item) }}
                                %
                            </p>
                        </div>
                    </template>
                    <template v-slot:[`item.actions`]="{ item }">
                        <div>
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn
                                        small
                                        icon
                                        v-bind="attrs"
                                        v-on="on"
                                        @click="openAssociateDialog(item)"
                                    >
                                        <v-icon>mdi-plus</v-icon>
                                    </v-btn>
                                </template>
                                <span>Associate Quote/Scope</span>
                            </v-tooltip>
                        </div>
                    </template>
                </v-data-table>
            </v-col>
        </v-row>
        <!-- Dialog close payroll -->
        <v-dialog
            :retain-focus="false"
            v-model="associateDialog"
            persistent
            max-width="600px"
        >
            <v-card>
                <v-card-title class="text-h5"
                    >Associated Quote/Scope</v-card-title
                >
                <v-card-text>
                    <v-data-table
                        id="virtual-scroll-table"
                        disable-pagination
                        hide-default-footer
                        :headers="headersAssociate"
                        :items="associateList"
                        class="elevation-0"
                        :mobile-breakpoint="0"
                        :loading="loading"
                        item-key="uniqueKey"
                    >
                        <template v-slot:top>
                            <v-row
                                no-gutter
                                class="pa-0 ma-0"
                                :style="{
                                    'background-color': '#eeeeee',
                                }"
                            >
                                <v-col cols="12" class="d-flex">
                                    <p
                                        class="text-h5 my-0 pl-3 font-weight-bold mr-4 mt-1"
                                    >
                                        {{ 'Details' }}
                                    </p>
                                    <v-spacer />
                                    <v-tooltip bottom>
                                        <template
                                            v-slot:activator="{
                                                on,
                                                attrs,
                                            }"
                                        >
                                            <v-btn
                                                small
                                                icon
                                                v-bind="attrs"
                                                v-on="on"
                                                @click="newAssociation()"
                                            >
                                                <v-icon>mdi-plus</v-icon>
                                            </v-btn>
                                        </template>
                                        <span>New Association</span>
                                    </v-tooltip>
                                </v-col>
                            </v-row>
                        </template>
                        <template v-slot:[`item.actions`]="{ item }">
                            <div>
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                            small
                                            icon
                                            v-bind="attrs"
                                            v-on="on"
                                            @click="deleteAssociation(item)"
                                        >
                                            <v-icon
                                                >mdi-trash-can-outline</v-icon
                                            >
                                        </v-btn>
                                    </template>
                                    <span>Delete Association</span>
                                </v-tooltip>
                            </div>
                        </template>
                    </v-data-table>
                </v-card-text>
                <v-card-actions>
                    <v-btn
                        text
                        color="secondary"
                        @click="closeAssociateDialog()"
                    >
                        Cancel
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn
                        @click="associateQuoteScope()"
                        text
                        :loading="loading"
                    >
                        Save
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!-- Dialog close payroll -->
        <v-dialog
            :retain-focus="false"
            v-model="selectDialog"
            persistent
            max-width="600px"
        >
            <v-card>
                <v-card-title class="text-h5"
                    >Select a Quote/Scope</v-card-title
                >
                <v-card-text>
                    <v-form
                        v-model="valid"
                        class="mx-5 mt-3"
                        :disabled="loading"
                    >
                        <v-row class="mt-0">
                            <v-col cols="12" class="py-0">
                                <v-autocomplete
                                    v-model="associationSelected"
                                    :items="filteredOptions"
                                    item-text="text"
                                    item-value="value"
                                    label="Quote/Scope"
                                    prepend-icon="mdi-form-select"
                                    :rules="[rules.required]"
                                    required
                                >
                                </v-autocomplete>
                            </v-col>
                        </v-row>
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-btn text color="secondary" @click="closeSelectDialog()">
                        Cancel
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn
                        @click="saveSelect()"
                        text
                        :loading="loading"
                        :disabled="
                            Object.keys(associationSelected).length === 0
                        "
                    >
                        Associate
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import API from '@/services/api'
import { mapActions, mapMutations } from 'vuex'
import _ from 'lodash'

export default {
    name: 'ProjectInstallations',
    props: {
        project: Object,
        clients: Array,
        users: Array,
        settings: Array,
        projectQuotes: {
            type: Array,
            default: () => [],
        },
    },
    data: () => ({
        quoteCompleteData: [],
        heightPopUp: 0,
        quotes: [],
        loading: false,
        headers: [
            {
                text: 'Quote ID',
                value: 'number',
                align: 'center',
            },
            {
                text: 'Quote Name',
                value: 'name',
                align: 'center',
            },
            {
                text: 'Scope Name',
                value: 'scopeName',
                align: 'center',
            },
            {
                text: 'Associated Scopes',
                value: 'associateScopes',
                align: 'center',
                sortable: false,
            },
            {
                text: 'SQFT',
                value: 'sqft',
                align: 'center',
            },
            {
                text: 'Installation Price',
                value: 'installation',
                align: 'center',
            },
            {
                text: 'Installation Price / SQFT',
                value: 'expected',
                align: 'center',
            },
            {
                text: 'Installation Time',
                value: 'installationTime',
                align: 'center',
            },
            {
                text: 'Installed Price',
                value: 'totalInstallation',
                align: 'center',
            },
            {
                text: 'Installed Price / SQFT',
                value: 'real',
                align: 'center',
            },
            {
                text: 'Execution (%)',
                value: 'efficiency',
                align: 'center',
            },
            {
                text: 'Actions',
                value: 'actions',
                align: 'center',
                sortable: false,
            },
        ],
        headersAssociate: [
            {
                text: 'Quote',
                value: 'quote',
                align: 'center',
            },
            {
                text: 'Scope',
                value: 'scope',
                align: 'center',
            },
            {
                text: 'Actions',
                value: 'actions',
                align: 'center',
                sortable: false,
            },
        ],
        quotesHeight: 0,
        selectedQuote: undefined,
        associateDialog: false,
        scopeSelected: {},
        associateList: [],
        selectDialog: false,
        associationSelected: {},
        valid: false,
        options: [],
        rules: {
            required: v => !!v || 'Required',
        },
    }),
    inject: {
        openQuoteFromProjects: {
            from: 'openQuoteFromProjects',
            default() {
                return null
            },
        },
    },
    watch: {
        filterQuotes: {
            immediate: true,
            handler() {
                this.getCosts()
            },
        },
    },
    computed: {
        filterQuotes() {
            if (this.quotes) {
                const quoteToSearch = this.project.quotes.map(quote => {
                    return quote.split('/')[0]
                })
                return this.quotes.filter(quote => {
                    return quoteToSearch.includes(quote.id)
                })
            } else {
                return []
            }
        },
        filteredOptions() {
            let associatedKeys = new Set(
                this.associateList.map(item => item.uniqueKey)
            )
            const result = new Set(
                this.quoteCompleteData.map(
                    quote => `${quote.id}/${quote.scope.id}`
                )
            )
            const exceptions = new Set(
                this.options
                    .filter(option => !result.has(option.value.uniqueKey))
                    .map(quote => quote.value.uniqueKey)
            )

            const forReturn = this.options.filter(
                option => !exceptions.has(option.value.uniqueKey)
            )
            if (this.scopeSelected?.scope?.id) {
                const parentKey = `${this.scopeSelected.id}/${this.scopeSelected.scope.id}`
                associatedKeys.add(parentKey)
            }
            return forReturn.filter(
                option => !associatedKeys.has(option.value.uniqueKey)
            )
        },
    },
    async mounted() {
        try {
            this.loading = true
            let tempQuotes = []
            if (this.projectQuotes.length == 0) {
                tempQuotes = await API.getProjectQuotes(this.project.id)
            } else {
                tempQuotes = _.cloneDeep(this.projectQuotes)
            }

            const tempQuotesWithCosts = []

            for (const item of tempQuotes) {
                const costs = await API.getCosts(item.id)
                tempQuotesWithCosts.push({ ...item, costs })
            }
            this.quotes = [...tempQuotesWithCosts]
            this.options = this.quoteCostOptions()
            this.onResize()
        } catch (error) {
            this.setErrorItems({
                source: this.$options.name,
                message: error.message,
            })
        } finally {
            this.loading = false
        }
    },
    methods: {
        ...mapActions(['addCostAction']),
        ...mapMutations(['setClientQuote', 'setErrorItems']),
        quoteCostOptions() {
            const validQuotes = this.quotes.filter(
                quote => Array.isArray(quote.costs) && quote.costs.length > 0
            )
            return validQuotes.flatMap(quote =>
                quote.costs.map(cost => ({
                    text: `(${quote.number}) ${quote.name} / ${cost.reference}`,
                    value: {
                        scope: cost.reference,
                        quote: quote.name,
                        scopeId: cost.id,
                        quoteId: quote.id,
                        uniqueKey: `${quote.id}/${cost.id}`,
                    },
                }))
            )
        },
        async getCosts() {
            try {
                this.loading = true
                let data = []
                let associatedScopes = new Set()
                for (const quote of this.filterQuotes) {
                    if (quote?.costs) {
                        quote.costs.forEach(cost => {
                            if (cost.type === 'cost') {
                                let costData = { ...cost }
                                let installationValue = 0
                                let SQFT = 0
                                SQFT += parseFloat(cost.quantity)
                                if (Array.isArray(cost.sections)) {
                                    cost.sections.forEach(obj => {
                                        if (Array.isArray(obj.items)) {
                                            obj.items.forEach(item => {
                                                if (item.installation) {
                                                    installationValue +=
                                                        (parseFloat(
                                                            cost.total2 ?? 0
                                                        ) *
                                                            parseFloat(
                                                                item.percentage ??
                                                                    0
                                                            )) /
                                                        100
                                                }
                                            })
                                        }
                                    })
                                }
                                if (
                                    Array.isArray(cost?.associateScopes) &&
                                    cost.associateScopes.length > 0
                                ) {
                                    cost.associateScopes.forEach(
                                        costAssociated => {
                                            associatedScopes.add(
                                                costAssociated.scopeId
                                            )
                                            const scope = this.filterQuotes
                                                .find(
                                                    quote =>
                                                        quote.id ===
                                                        costAssociated.quoteId
                                                )
                                                ?.costs?.find(
                                                    cost =>
                                                        cost.id ===
                                                        costAssociated.scopeId
                                                )
                                            if (scope) {
                                                SQFT += parseFloat(
                                                    scope.quantity
                                                )
                                                if (
                                                    Array.isArray(
                                                        scope.sections
                                                    )
                                                ) {
                                                    scope.sections.forEach(
                                                        obj => {
                                                            if (
                                                                Array.isArray(
                                                                    obj.items
                                                                )
                                                            ) {
                                                                obj.items.forEach(
                                                                    item => {
                                                                        if (
                                                                            item.installation
                                                                        ) {
                                                                            installationValue +=
                                                                                (parseFloat(
                                                                                    scope.total2 ??
                                                                                        0
                                                                                ) *
                                                                                    parseFloat(
                                                                                        item.percentage ??
                                                                                            0
                                                                                    )) /
                                                                                100
                                                                        }
                                                                    }
                                                                )
                                                            }
                                                        }
                                                    )
                                                }
                                            }
                                        }
                                    )
                                }

                                costData.SQFT = SQFT
                                costData.installationValue = installationValue
                                data.push({ ...quote, scope: costData })
                            }
                        })
                    }
                }

                data = data.filter(item => !associatedScopes.has(item.scope.id))
                const payrolls = await API.getPayrolls({
                    projectId: this.project.id,
                })
                payrolls.forEach(payroll => {
                    ;(payroll.externalUsersData || []).forEach(user => {
                        const cost = user.selectedCost?.cost
                        const quote = user.selectedCost?.quote
                        const clockIn = user.clockIn
                        const clockOut = user.clockOut
                        if (cost && quote && clockIn && clockOut) {
                            const clockInSec =
                                clockIn._seconds + clockIn._nanoseconds / 1e9
                            const clockOutSec =
                                clockOut._seconds + clockOut._nanoseconds / 1e9
                            const rawHours = (clockOutSec - clockInSec) / 3600
                            const hours = parseFloat(rawHours.toFixed(2))
                            const hourlyPrice = parseFloat(
                                payroll.hourlyPrice || 0
                            )
                            const calculatedCost = parseFloat(
                                (hours * hourlyPrice).toFixed(2)
                            )
                            const matched = data.find(
                                d =>
                                    d.id === quote.id &&
                                    d.scope &&
                                    d.scope.id === cost.id
                            )
                            if (matched && matched.scope) {
                                matched.scope.hours =
                                    (matched.scope.hours || 0) + hours
                                matched.scope.totalInstallation =
                                    (matched.scope.totalInstallation || 0) +
                                    calculatedCost
                            }
                        }
                    })
                })

                this.quoteCompleteData = data
            } catch (error) {
                this.setErrorItems({
                    source: this.$options.name,
                    message: error.message,
                })
            } finally {
                this.loading = false
            }
        },
        calculatedExecution(item) {
            return parseFloat(item.scope.totalInstallation || 0) > 0 &&
                parseFloat(item.scope.installationValue) > 0
                ? (
                      (parseFloat(item.scope.totalInstallation) /
                          parseFloat(item.scope.installationValue)) *
                      100
                  ).toFixed(2)
                : 0
        },
        onResize() {
            this.quotesHeight =
                window.innerHeight - this.$vuetify.application.top - 80
            this.heightPopUp = window.innerHeight - 62
        },
        formatCurrency(value, currency) {
            return new Intl.NumberFormat('de-DE', {
                style: 'currency',
                currency: currency,
                minimumFractionDigits: 0,
            }).format(value ? value.toFixed(2) : 0)
        },
        async associateQuoteScope() {
            try {
                if (this.scopeSelected?.scope?.id) {
                    await API.updateAssociateInstallation(
                        this.scopeSelected.id,
                        this.scopeSelected.scope.id,
                        { associateScopes: this.associateList }
                    )
                }
                const quoteIndex = this.quotes.findIndex(
                    quote => quote.id === this.scopeSelected.id
                )
                if (quoteIndex > -1) {
                    const quote = this.quotes[quoteIndex]
                    const scopeIndex = quote.costs.findIndex(
                        cost => cost.id === this.scopeSelected.scope.id
                    )
                    if (scopeIndex > -1) {
                        const scope = quote.costs[scopeIndex]
                        this.$set(scope, 'associateScopes', this.associateList)
                        this.$set(this, 'quotes', [...this.quotes])
                    }
                }
            } catch (error) {
                console.error(error)
            } finally {
                this.closeAssociateDialog()
            }
        },
        openAssociateDialog(item) {
            this.scopeSelected = _.cloneDeep(item)
            if (this.scopeSelected.scope.associateScopes) {
                this.associateList = _.cloneDeep(
                    this.scopeSelected.scope.associateScopes
                )
            } else {
                this.associateList = []
            }
            this.associateDialog = true
        },
        closeAssociateDialog() {
            this.associateDialog = false
            this.scopeSelected = {}
            this.associateList = []
        },
        newAssociation() {
            this.selectDialog = true
        },
        deleteAssociation(item) {
            const index = this.associateList.findIndex(
                obj => obj.uniqueKey === item.uniqueKey
            )
            if (index > -1) {
                this.associateList.splice(index, 1)
            }
        },
        closeSelectDialog() {
            this.selectDialog = false
            this.associationSelected = {}
        },
        saveSelect() {
            try {
                this.associateList.push(this.associationSelected)
            } catch (error) {
                console.error(error)
            } finally {
                this.closeSelectDialog()
            }
        },
    },
}
</script>

<style scoped>
.v-data-table {
    border: 1px solid #eeeeee;
}
.v-data-table >>> thead {
    background-color: #eeeeee;
}
#virtual-scroll-table {
    width: 100%;
    overflow: auto;
}
</style>
